import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsComponent } from '../../../components/online-design/online-product-details/comments/comments.component';
import { DetailsCubeComponent } from '../../../components/online-design/online-product-details/details-cube/details-cube.component';
import { QuestionsComponent } from '../../../components/online-design/online-product-details/questions/questions.component';
import { OnlineProductDetailsComponent } from '../../../components/online-design/online-product-details/online-product-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {

  faShoppingCart,
  faStar,
  faStarHalf, faArrowCircleRight,
  faArrowCircleLeft,
  faFilePdf,
  faCommentAlt,
  faPrint,
  faLink,
  faEnvelope,
  faEllipsisH,
  faMinus, faBars, faShoppingBasket, faAngleDown, faAngleUp, faComment, faPhoneSlash, faPhoneSquare, faQuestion, faSearch, faCheck, fas
} from '@fortawesome/free-solid-svg-icons';
import {
  faTwitter, faFacebookF, faGooglePlusG, faLinkedinIn,
  faPinterestP, faWhatsapp, faTelegramPlane, faFacebookMessenger
} from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { NgbCarouselModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareModule } from '../../share/share.module';
import { ProductPriceListComponent } from 'src/app/components/online-design/online-product-details/price-list/product-price-list.component';
import { DynamicOptionsPricelistComponent } from 'src/app/components/online-design/online-product-details/price-list/dynamic-options-pricelist/dynamic-options-pricelist.component';
import { ProductDescriptionComponent } from 'src/app/components/online-design/online-product-details/product-description/product-description.component';
import { PlanExamplesComponent } from 'src/app/components/online-design/online-product-details/plan-examples/plan-examples.component';
import { PictureSliderComponent } from 'src/app/components/online-design/online-product-details/plan-examples/picture-slider/picture-slider.component';
import { CommentFormComponent } from 'src/app/components/online-design/online-product-details/comments/comment-form/comment-form.component';
import { ProductDetailsUiStateService } from 'src/app/components/online-design/online-product-details/product-details-ui-state.service';
import { ProductDetailsStep1Component } from 'src/app/components/online-design/online-product-details/product-details-step1/product-details-step1.component';
import { ProductDetailsStep2Component } from 'src/app/components/online-design/online-product-details/product-details-step2/product-details-step2.component';
import { DynamicOptionFieldsComponent } from "../../../components/online-design/online-product-details/product-details-step1/dynamic-option-fields/dynamic-option-fields.component";

const routes: Routes = [
  { path: '', component: OnlineProductDetailsComponent },
  {
    path: 'archonline_product_details/:id',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'archonline_product_details/:id/:i',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'archonline_product_details_part2/:id',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'archonline_product_details_part2/:id/:i',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'product/:id/:title',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'product/:id/:i/:title',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'product2/:id/:title',
    component: OnlineProductDetailsComponent
  },
  {
    path: 'product2/:id/:i/:title',
    component: OnlineProductDetailsComponent
  },
];

@NgModule({
    declarations: [
        OnlineProductDetailsComponent,
        QuestionsComponent,
        DetailsCubeComponent,
        CommentsComponent,
        ProductPriceListComponent,
        DynamicOptionsPricelistComponent,
        ProductDescriptionComponent,
        PlanExamplesComponent,
        PictureSliderComponent,
        CommentFormComponent,
        ProductDetailsStep1Component,
        ProductDetailsStep2Component
    ],
    providers: [ProductDetailsUiStateService],
    imports: [
        NgbCarouselModule,
        CommonModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(routes),
        FontAwesomeModule,
        ShareModule,
        RecaptchaModule,
        DynamicOptionFieldsComponent
    ]
})
export class ProductDetailsModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
    library.addIconPacks(far);
    library.addIcons(
      faShoppingCart, faStar, faArrowCircleRight,
      faArrowCircleLeft, faFilePdf, faFacebookF, faTwitter,
      faGooglePlusG, faLinkedinIn, faPinterestP, faWhatsapp,
      faFacebookMessenger, faTelegramPlane, faCommentAlt,
      faEnvelope, faLink, faPrint, faStarHalf,
      faEllipsisH, faMinus, faBars, faShoppingBasket,
      faAngleDown, faAngleUp, faComment, faPhoneSquare,
      faQuestion, faSearch, faCheck
    );
  }
}
